export const favouritesActionTypes = {
    ADD_TO_FAVOURITES: 'ADD_TO_FAVOURITES',
    REMOVE_FROM_FAVOURITES: 'REMOVE_FROM_FAVOURITES',
    GET_ALL_FAVOURITES: 'GET_ALL_FAVOURITES'
}